<div class="pending-reviews-banner" role="status" *ngIf="pending() > 0">
  <svg class="prb-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
  <p class="prb-text"><strong>{{ headline() }}</strong> {{ detail() }}</p>
  <a class="prb-link" routerLink="/version-review">Go to Version Review</a>
</div>
